export const consoleEditorClass = 'language-scala';
export const consoleErrorClass = 'result-error';
export const tabSize = 4;
